export const CUT_OFF_QUICK_COMMENTS = [
    "без остатка",
    "с царапинами",
    "брак ламинации",
    "дополнительно",
];
